/**
 * deepdive-v2's rules for a new password (`apps/api/src/user/user.dto.ts`,
 * `UpdatePasswordSchema`), with its messages, in its order. v2 checks them too,
 * but answers a broken rule with a bare "Validation failed", so the reason is
 * found here first. Change both together.
 */
const SPECIAL = /[@$!%*?&_#.+-]/;
const ALLOWED = /^[A-Za-z\d@$!%*?&_#.+-]*$/;

/** The first rule the new password breaks, or `undefined` when it passes them all. */
export function newPasswordProblem(oldPassword: string, newPassword: string): string | undefined {
  const next = newPassword.trim();
  if (!oldPassword.trim()) return 'Old password is required';
  if (next.length < 8) return 'New password must be at least 8 characters';
  if (next.length > 64) return 'New password must be at most 64 characters';
  if (!/[a-z]/.test(next)) return 'New password must include a lowercase letter';
  if (!/[A-Z]/.test(next)) return 'New password must include an uppercase letter';
  if (!/\d/.test(next)) return 'New password must include a number';
  if (!SPECIAL.test(next))
    return 'New password must include a special character (@ $ ! % * ? & _ # . - +)';
  if (!ALLOWED.test(next))
    return 'New password can only contain letters, numbers and @ $ ! % * ? & _ # . - +';
  if (next === oldPassword.trim()) return 'New password must be different from your old password';
  return undefined;
}
